import { Pipe, PipeTransform } from '@angular/core';

import { Document, CustomSigner } from '@app/models';
import { DocumentService } from '@app/services';
import { isEqual } from 'lodash';

@Pipe({
  name: 'sortByCurrentSigners',
  pure: false,
  standalone: false
})
export class SortByCurrentSignersPipe implements PipeTransform {
  private lastSigners: Document['signatures'] | null = null;
  private lastDocument: Document | null = null;
  private lastCurrentSigners: CustomSigner[] | null = null;
  private lastResult: Document['signatures'] = [];

  constructor(private documentService: DocumentService) {}

  transform(signers: Document['signatures'], document: Document, currentSigners: CustomSigner[]) {
    if (isEqual(signers, this.lastSigners) && isEqual(document, this.lastDocument) && isEqual(currentSigners, this.lastCurrentSigners)) {
      return this.lastResult;
    }

    this.lastSigners = signers;
    this.lastDocument = document;
    this.lastCurrentSigners = currentSigners;
    if (signers && document && !document.sortable && (currentSigners || []).length > 0) {
      const currentSignersPublicIds = currentSigners.map(sig => sig.public_id);
      this.lastResult = (signers || []).slice().sort(sig => (currentSignersPublicIds.includes(sig.public_id) && this.documentService.isSignerPending(sig) ? -1 : 1));
    } else {
      this.lastResult = signers;
    }
    return this.lastResult;
  }
}
